export var OrganisationEmailType;
(function (OrganisationEmailType) {
    // FREE TRIAL EMAILS
    OrganisationEmailType["FREE_ACTIONS_LIMIT_REACHED"] = "FREE_ACTIONS_LIMIT_REACHED";
    OrganisationEmailType["FREE_ACTIONS_WARNING_5_REMAINING"] = "FREE_ACTIONS_WARNING_5_REMAINING";
    /** When we have a broken connection */
    OrganisationEmailType["DISCONNECT_BROKEN"] = "DISCONNECT_BROKEN";
    /** When they had no valid subscription */
    OrganisationEmailType["DISCONNECT_NO_SUBSCRIPTION"] = "DISCONNECT_NO_SUBSCRIPTION";
})(OrganisationEmailType || (OrganisationEmailType = {}));
export var OrganisationEmailStatus;
(function (OrganisationEmailStatus) {
    OrganisationEmailStatus["PENDING"] = "pending";
    OrganisationEmailStatus["SENT"] = "sent";
    OrganisationEmailStatus["FAILED"] = "failed";
})(OrganisationEmailStatus || (OrganisationEmailStatus = {}));
//# sourceMappingURL=organisationEmails.js.map